import { render, staticRenderFns } from "./cModalMedicDespachado.vue?vue&type=template&id=7818d4a3&scoped=true"
import script from "./cModalMedicDespachado.vue?vue&type=script&lang=js"
export * from "./cModalMedicDespachado.vue?vue&type=script&lang=js"
import style0 from "./cModalMedicDespachado.vue?vue&type=style&index=0&id=7818d4a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7818d4a3",
  null
  
)

export default component.exports